import { useState } from "react";

// Components
import { SelectedUsersContext } from "../context/SelectedUsersContext";
import UsersDataGrid from "./UsersDataGrid";
import UsersToolbar from "./UsersToolbar";
import UserDeleteDialog from "./UserDeleteDialog";
import UserDrawer from "./UserDrawer";
import IdentityInvite from "../../identity/components/IdentityInvite";

function Users() {
  const [isCreatorOpen, setIsCreatorOpen] = useState(false);
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [isRemoverOpen, setIsRemoverOpen] = useState(false);
  const [isInviteOpen, setIsInviteOpen] = useState(false);

  return (
    <SelectedUsersContext>
      <UsersToolbar
        setIsAddOpen={setIsCreatorOpen}
        setIsEditOpen={setIsEditorOpen}
        setIsRemoverOpen={setIsRemoverOpen}
        setIsInviteOpen={setIsInviteOpen}
      />
      <div style={{ flex: 1, overflowY: "auto" }}>
        <UsersDataGrid data-testid="users-datagrid" />
      </div>
      <UserDrawer isOpen={isCreatorOpen} setIsOpen={setIsCreatorOpen} newUser={true} />
      <UserDrawer isOpen={isEditorOpen} setIsOpen={setIsEditorOpen} newUser={false} />
      {isRemoverOpen && <UserDeleteDialog isOpen={isRemoverOpen} setIsOpen={setIsRemoverOpen} />}
      {isInviteOpen && <IdentityInvite isOpen={isInviteOpen} setIsOpen={setIsInviteOpen} />}
    </SelectedUsersContext>
  );
}

export default Users;
